"use client";

import { Layout, PharadayLogoIcon, ResourceAccessRestriction } from "@pharaday/lighthouse";
import { NamespaceContainerProvider } from "@pharaday/namespace";
import Link from "next/link";

import { AuthenticatedContainer } from "../../core/authenticated.container";
import { ApplicationsAndToolsDropdown } from "../applications-and-tools-dropdown";
import { UserMenu } from "../user-menu";

const NotFoundNavigation = () => {
  return (
    <NamespaceContainerProvider container={AuthenticatedContainer}>
      <Layout.Root>
        <Layout.Content>
          <Layout.ContentHeader>
            <Layout.ContentHeaderTopNav>
              <Link href="/">
                <div className={"flex items-center gap-2.5"}>
                  <PharadayLogoIcon className="h-7 w-7" />
                  <span className="text-base font-bold text-[#191C1E]">Pharaday</span>
                </div>
              </Link>
              <div className="flex items-center gap-2">
                <ApplicationsAndToolsDropdown />
                <UserMenu />
              </div>
            </Layout.ContentHeaderTopNav>
          </Layout.ContentHeader>
          <Layout.ContentBody className="items-center">
            <ResourceAccessRestriction />
          </Layout.ContentBody>
        </Layout.Content>
      </Layout.Root>
    </NamespaceContainerProvider>
  );
};

export default NotFoundNavigation;
